import { Webhook, Flower, DraftingCompass, Store } from "lucide-react";
import "../assets/main.css"
import { cn } from "../utils/cn";
import { BentoCard, BentoGrid } from "../Bentogrid";
/* import { Gifweb } from "../components/Gifweb"; */
import { GifwebOne } from "../components/GifwebOne";
import { GifwebTwo } from "../components/GifwebTwo";
import { GifwebThree } from "../components/GifwebThree";
import { GifwebFour } from "../components/GifwebFour";



const files = [
  {
    name: "bitcoin.pdf",
    body: "Bitcoin is a cryptocurrency invented in 2008 by an unknown person or group of people using the name Satoshi Nakamoto.",
  },
  {
    name: "finances.xlsx",
    body: "A spreadsheet or worksheet is a file made of rows and columns that help sort data, arrange data easily, and calculate numerical data.",
  },
  {
    name: "logo.svg",
    body: "Scalable Vector Graphics is an Extensible Markup Language-based vector image format for two-dimensional graphics with support for interactivity and animation.",
  },
  {
    name: "keys.gpg",
    body: "GPG keys are used to encrypt and decrypt email, files, directories, and whole disk partitions and to authenticate messages.",
  },
  {
    name: "seed.txt",
    body: "A seed phrase, seed recovery phrase or backup seed phrase is a list of words which store all the information needed to recover Bitcoin funds on-chain.",
  },
];

const PlaceholderIcon = () => <div className="h-12 w-12 bg-gray-300" />;

const features = [
  
  {
    Icon: DraftingCompass || PlaceholderIcon,
    name: "Framer Design",
    description: "We harness Frame to build an unique web for you.",
    href: "https://api.whatsapp.com/send?phone=3143468608",
    cta: "Contact us now",
    className: "col-span-3 lg:col-span-1",
    background: <GifwebOne />,
  },
  {
    Icon: Webhook,
    name: "NextJS Design",
    description: "We leverage the Next.JS components power within your website.",
    href: "https://api.whatsapp.com/send?phone=3143468608",
    cta: "Contact us now",
    className: "col-span-3 lg:col-span-2",
    background: <GifwebTwo />,
  },
  {
    Icon: Store,
    name: "Shopify Design",
    description: "We build an aesthetic website making the most of Shopify's funtionlity.",
    href: "https://api.whatsapp.com/send?phone=3143468608",
    cta: "Contact us now",
    className: "col-span-3 lg:col-span-2",
    background: <GifwebThree />,
  },
  {
    Icon: Flower,
    name: "Web Design",
    description: "We take advantage of weflow and the latest trends to boost your website.",
    href: "https://api.whatsapp.com/send?phone=3143468608",
    cta: "Contact us now",
    className: "col-span-3 lg:col-span-1",
    background: <GifwebFour />,
  }
];

export function BentoDemoStack() {
  return (
    <BentoGrid>
      {features.map((feature, index) => (
          <BentoCard key={index} {...feature} />
      ))}
    </BentoGrid>
  );
}

  